(() => {
  document.querySelectorAll('[data-kk-waf-mini]').forEach((root) => {
    const width = root.querySelector('[data-kk-waf-mini-width]');
    const depth = root.querySelector('[data-kk-waf-mini-depth]');
    const widthOutput = root.querySelector('[data-kk-waf-mini-width-output]');
    const depthOutput = root.querySelector('[data-kk-waf-mini-depth-output]');
    const sizeOutput = root.querySelector('[data-kk-waf-mini-size-label]');
    const selectionOutput = root.querySelector('[data-kk-waf-mini-selection]');
    const continueLink = root.querySelector('[data-kk-waf-mini-continue]');
    const outerPath = root.querySelector('[data-kk-waf-svg-outer]');
    const innerPath = root.querySelector('[data-kk-waf-svg-inner]');
    const widthLine = root.querySelector('[data-kk-waf-svg-width-line]');
    const depthLine = root.querySelector('[data-kk-waf-svg-depth-line]');
    const widthLabel = root.querySelector('[data-kk-waf-svg-width-label]');
    const depthLabel = root.querySelector('[data-kk-waf-svg-depth-label]');
    if (!width || !depth || !continueLink || !outerPath || !innerPath) return;

    const updateGraphic = () => {
      const w = Number(width.value);
      const d = Number(depth.value);
      const left = 42 - ((w - 45) / 55) * 18;
      const right = 158 + ((w - 45) / 55) * 18;
      const top = 20;
      const bottom = 120 + ((d - 60) / 30) * 20;
      const innerLeft = left + 18;
      const innerRight = right - 18;
      outerPath.setAttribute('d', `M ${left + 3} ${top} C ${left + 1} ${top}, ${left} ${top + 2}, ${left} ${top + 5} L ${left} ${bottom - 5} C ${left} ${bottom - 2}, ${left + 2} ${bottom}, ${left + 5} ${bottom} L ${right - 5} ${bottom} C ${right - 2} ${bottom}, ${right} ${bottom - 2}, ${right} ${bottom - 5} L ${right} ${top + 5} C ${right} ${top + 2}, ${right - 1} ${top}, ${right - 3} ${top} Z`);
      innerPath.setAttribute('d', `M ${innerLeft} 39 L ${innerLeft} ${bottom - 10} M ${innerLeft} 39 L ${innerRight} 39 L ${innerRight} ${bottom - 10}`);
      widthLine?.setAttribute('d', `M ${left} ${bottom + 8} L ${right} ${bottom + 8}`);
      depthLine?.setAttribute('d', `M ${left - 10} ${top} L ${left - 10} ${bottom}`);
      widthLabel?.setAttribute('x', `${(left + right) / 2}`);
      widthLabel?.setAttribute('y', `${bottom + 17}`);
      if (widthLabel) widthLabel.textContent = `${w} cm`;
      if (depthLabel) {
        depthLabel.textContent = `${d} cm`;
        depthLabel.setAttribute('y', `${(top + bottom) / 2}`);
        depthLabel.setAttribute('transform', `rotate(-90 ${left - 17} ${(top + bottom) / 2})`);
      }
      if (widthOutput) widthOutput.textContent = `${w} cm`;
      if (depthOutput) depthOutput.textContent = `${d} cm`;
      if (sizeOutput) sizeOutput.textContent = `${w} × ${d} cm`;
      if (selectionOutput) selectionOutput.textContent = `${w} × ${d} cm`;
      try { sessionStorage.setItem('kkWafMiniSelection', JSON.stringify({ width: w, depth: d })); } catch (error) { /* private mode */ }
      const target = new URL(root.dataset.kkWafMiniLargeUrl || continueLink.href, window.location.origin);
      target.searchParams.set('kk_mini_width', w);
      target.searchParams.set('kk_mini_depth', d);
      continueLink.href = target.toString();
    };

    [width, depth].forEach((input) => input.addEventListener('input', updateGraphic));
    updateGraphic();
  });
})();